import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=585a78c4&"
import script from "./DateRangePicker.vue?vue&type=script&lang=js&"
export * from "./DateRangePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585a78c4')) {
      api.createRecord('585a78c4', component.options)
    } else {
      api.reload('585a78c4', component.options)
    }
    module.hot.accept("./DateRangePicker.vue?vue&type=template&id=585a78c4&", function () {
      api.rerender('585a78c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/DateRangePicker.vue"
export default component.exports